import { Typography } from "@mui/material";
import Linkify from "linkify-react";

export interface GenericDescriptionProps {
  /**
   * The description text to display
   */
  description: string;
  /**
   * Optional className for styling
   */
  className?: string;
  /**
   * Optional style overrides
   */
  sx?: object;
}

/**
 * GenericDescription component for displaying text with proper line breaks and linkified URLs
 * This is an atom component that handles the basic text display concerns
 */
export const GenericDescription = ({ description, className, sx }: GenericDescriptionProps) => {
  return (
    <Typography
      variant="body1"
      className={className}
      sx={{
        maxWidth: "100%",
        overflowWrap: "break-word",
        whiteSpace: "pre-line",
        wordBreak: "break-word",
        ...sx,
      }}
    >
      <Linkify
        options={{
          rel: "noopener noreferrer",
          style: { maxWidth: "100%", wordBreak: "break-word" },
          target: "_blank",
        }}
      >
        {description}
      </Linkify>
    </Typography>
  );
};
